import { Reveal, type RevealVariant } from "./Reveal";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

/**
 * Legacy FadeUp — kept so existing pages don't break.
 * Thin wrapper over the new Reveal component with the same prop shape.
 */
export function FadeUp({
  children,
  className,
  delay = 0,
  variant = "up" as RevealVariant,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
  variant?: RevealVariant;
}) {
  return (
    <Reveal variant={variant} delay={delay} className={cn(className)}>
      {children}
    </Reveal>
  );
}
